import { render, staticRenderFns } from "./PTopResultStasus.vue?vue&type=template&id=1f538224&functional=true&"
import script from "./PTopResultStasus.vue?vue&type=script&lang=js&"
export * from "./PTopResultStasus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports